import { EasyEventEmitter } from '@d/util'

export const stateScope = Symbol('StateScope') as InjectionKey<{
  dialog: Ref<boolean>
  loadingBlocking: Set<string>
  watchShortcut: (keys: string, callback: () => void) => () => void
  useLoadblocker: (index: string) => WritableComputedRef<boolean>
  isLoadingBlocking: ComputedRef<boolean>
  ee: EasyEventEmitter<any>
  treeFocus: Ref<boolean>
}>

export function provideStateScope() {
  const dialog = ref(false)
  const loadingBlocking = reactive(new Set<string>())
  const treeFocus = ref(false)

  const ee = new EasyEventEmitter()

  function useLoadblocker(index: string): WritableComputedRef<boolean> {
    const x = computed({
      get() {
        return loadingBlocking.has(index)
      },
      set(value: boolean) {
        if (value) {
          loadingBlocking.add(index)
        }
        else {
          loadingBlocking.delete(index)
        }
      },
    })

    onBeforeUnmount(() => {
      x.value = false
    })

    return x
  }

  // const isLoadingBlocking = computed(() => true)
  const isLoadingBlocking = computed(() => loadingBlocking.size > 0)

  function watch(keys: string, callback: () => void) {
    const cbClone = () => callback()
    ee.on(keys, cbClone)

    onBeforeUnmount(() => {
      ee.off(keys, cbClone)
    })

    return () => {
      ee.off(keys, cbClone)
    }
  }

  provide(stateScope, { dialog, watchShortcut: watch, ee, isLoadingBlocking, useLoadblocker, loadingBlocking, treeFocus })
}

export function useStateScope() {
  return inject(stateScope)
}
